import { render, staticRenderFns } from "./EmployeeAvatar.vue?vue&type=template&id=bd161504&scoped=true"
import script from "./EmployeeAvatar.vue?vue&type=script&lang=js"
export * from "./EmployeeAvatar.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAvatar.vue?vue&type=style&index=0&id=bd161504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd161504",
  null
  
)

export default component.exports